<template>
  <section class="section">
    <div class="container">
      <h2 class="section-title">AI算力交付案例</h2>
      <p class="section-subtitle">从签约到交付，用实际成果证明实力</p>
      <div class="cases-grid">
        <div v-for="c in caseStudies" :key="c.title" class="feature-card">
          <div class="feature-tag"></div>
          <h3>{{ c.title }}</h3>
          <p class="case-summary" v-html="c.summary" />
          <ul class="case-metrics">
            <li v-for="item in c.metrics" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="metrics-strip">
        <template v-for="(m, i) in metrics" :key="m.label">
          <div class="metric-item">
            <div class="metric-value">{{ m.value }} <span class="metric-dw">{{ m.dw }}</span></div>
            <div class="metric-label">{{ m.label }}</div>
          </div>
          <svg
            v-if="i < metrics.length - 1"
            class="metric-divider"
            xmlns="http://www.w3.org/2000/svg"
            width="1"
            height="98"
            viewBox="0 0 1 98"
            fill="none"
            aria-hidden="true"
          >
            <path d="M0.5 0V98" :stroke="`url(#paint0_linear_metric_${i})`" />
            <defs>
              <linearGradient :id="`paint0_linear_metric_${i}`" x1="1" y1="98" x2="1" y2="0" gradientUnits="userSpaceOnUse">
                <stop stop-color="white" stop-opacity="0" />
                <stop offset="0.5" stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0.01" />
              </linearGradient>
            </defs>
          </svg>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const caseStudies = [
  {
    title: '摩尔线程 AI 算力集群',
    summary: '60天交付89台服务器集群（行业平均90天），含82台海光液冷高性能计算节点（Hygon 7490）与7套分布式存储系统（Hygon 7420D）。',
    metrics: [
      'GPU利用率稳定85%+',
      '液冷+国产GPU全栈适配，国内早期规模化落地案例',
      'AI训练性能达设计预期，通过Benchmark验证'
    ]
  },
  {
    title: '中科院新疆理化所超算集群',
    summary: '29台服务器跨地域远程交付，克服新疆物流与时差挑战。27台高性能计算节点部署与网络调优。',
    metrics: [
      '材料物理模拟周期从2周压缩至 5天',
      '效率提升50%，全年可用性 99.95%',
      '通过中科院信息化专项验收'
    ]
  },
  {
    title: '商飞软件航空仿真集群',
    summary: '33台国产海光处理器集群（26台R6250H0+7台5250H0），30天极速交付，保障国产大飞机研发节点。',
    metrics: [
      '航空仿真计算效率提升 >40%+',
      '单次成本降低 35%',
      '万兆网络架构+集群软件部署'
    ]
  }
];

const metrics = [
  { value: '7', label: 'HPC集群签约到交付', dw: '天' },
  { value: '30', label: '商飞软件集群交付', dw: '天' },
  { value: '60', label: '摩尔线程89台集群', dw: '天' },
  { value: '85%', label: 'GPU利用率稳定', dw: '+' }
];
</script>

<style scoped lang="scss">
.section {
  background: linear-gradient(0deg, #0E2661 0%, #2E2E2E 100%);
}

.cases-grid {
  margin-top: 64px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;

  .feature-tag {
    background: #0095FF;
    width: 36px;
    height: 4px;
    margin-bottom: 24px;
  }

  .feature-card {
    padding: 24px;
  }
}

.cases-grid h3 {
  font-family: "Noto Sans SC";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 1.92px;
}

.case-summary {
  margin-bottom: 16px;
  font-family: "Noto Sans SC";
  font-size: 14px;
  color: #fff;
  opacity: 0.7;
  font-weight: 400;
  line-height: 24px;
}

.case-metrics {
  margin: 0;
  padding-left: 1.25em;
  list-style: disc;
  font-family: "Noto Sans SC";
  font-size: 14px;
  color: #fff;
  opacity: 0.7;
  font-weight: 400;
  line-height: 24px;

  li+li {
    margin-top: 4px;
  }
}

.metrics-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 48px;
  text-align: center;
  padding: 0 32px;
}

.metric-item {
  flex: 1;
  min-width: 0;
}

.metric-divider {
  flex-shrink: 0;
  align-self: center;
}

@media (max-width: 768px) {
  .metrics-strip {
    flex-direction: column;
    gap: 32px;
  }

  .metric-divider {
    display: none;
  }
}

.metric-value {
  font-family: "Fira Sans";
  font-size: 64px;
  font-style: italic;
  font-weight: 900;
  align-self: stretch;
  margin-bottom: 24px;
}
.metric-dw {
  font-size: 20px;
  font-style: normal;
}

.metric-label {

  /* Noto Sans SC Regular 14 24 */
  font-family: "Noto Sans SC";
  font-size: 14px;
  line-height: 24px;
  color: #a4abbc;
  
  /* 171.429% */
}
</style>
